import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { ENV_CONFIG } from '@ps/core-config';
import { withLoading } from '@ps/core-loading';
import { type FusionStats } from '@ps/survey-utils';

import { FusionStatsMapper } from './fusion-stats.mapper';
import { FusionStatsDto, SurveyBlockActionResponseDto } from './fusion.dto';

@Injectable({ providedIn: 'root' })
export class FusionApi {
  private readonly _env = inject(ENV_CONFIG);
  private readonly _http = inject(HttpClient);

  private readonly _baseUrl = `${this._env.pureSpectrum.url}`;
  private readonly _fusionStatsMapper = new FusionStatsMapper();

  public createPriceBlock(surveyId: number): Observable<string> {
    return this._http
      .get<SurveyBlockActionResponseDto>(
        `${this._baseUrl}/surveys/createBlock/${surveyId}`,
        { context: withLoading('drawer') },
      )
      .pipe(map((dto) => dto.msg));
  }

  public resetFusionBlockStats(surveyId: number): Observable<string> {
    return this._http
      .put<SurveyBlockActionResponseDto>(
        `${this._baseUrl}/surveys/resetFusionBlockStats/${surveyId}`,
        {},
        { context: withLoading('drawer') },
      )
      .pipe(map((dto) => dto.msg));
  }

  public getFusionStats(surveyId: number): Observable<FusionStats> {
    return this._http
      .get<FusionStatsDto>(`${this._baseUrl}/surveys/fusionStats/${surveyId}`, {
        context: withLoading('drawer'),
      })
      .pipe(map((dto) => this._fusionStatsMapper.fromDto(dto)));
  }
}
